import { Chat } from "../chat"

window.chat = new Chat()

$(document).on('turbolinks:load', function(){
	window.chat.initialize()
});